import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import { MasterMessage } from '../../../masters/masterMessages';
import Grid from '@mui/material/Grid';
import ButtonGeneral from '../../components/general/buttons/buttonGeneral';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CancelIcon from '@mui/icons-material/Cancel';
import DropZoneField from '../../components/general/fields/dropzoneField';
import ModalLoading from '../../components/general/loading/modalLoading';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import { asyncPostCaseClosure } from '../../../services/caseClosure.service';
import Swal from 'sweetalert2';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    saveLoad: (value: boolean) => void;
};

const ModalCaseClosure = ({ open, onClose, saveLoad }: Props) => {
    const [files, setFiles] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const { titleNew, titleModalLoading, messageModalLoading, messageError } =
        MasterMessage.caseClosure;

    const handleClick = () => {
        if (files.length > 0) {
            onClose(false);
            setLoading(true);
            asyncPostCaseClosure(files[0])
                .then((body: any) => {
                    if (body.items !== undefined) {
                        saveLoad(true);
                        Swal.fire({
                            title: 'Carga Exitosa',
                            text:
                                body.items.repeatLength > 0 &&
                                body.items.length > 0
                                    ? `Se cargaron ${body.items.length} registros exitosamente, 
                             y ${body.items.repeatLength} ya estaban cargados`
                                    : body.items.repeatLength > 0 &&
                                      body.items.length === 0
                                        ? `Los ${body.items.repeatLength} registros ya existen`
                                        : `Se cargaron ${body.items.length} registros exitosamente`,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debes seleccionar algún archivo',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    return (
        <>
            <Modal
                open={open}
                onClose={() => onClose(false)}
                closeOnOverlayClick={false}
                styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
            >
                <Box>
                    <Typography
                        color="primary"
                        component="h3"
                        sx={{
                            fontSize: { lg: 27, xs: 23 },
                            mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                        }}
                    >
                        {titleNew}
                    </Typography>
                    <hr />
                    <Box mt={3} px={1}>
                        <Grid
                            container
                            spacing={{ xs: 2, md: 2 }}
                            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        >
                            <Grid item xs={12}>
                                <DropZoneField
                                    name="Cargue Masivo"
                                    maxFiles={1}
                                    accept=".xlsx"
                                    onChange={(value) => setFiles(value)}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                <ButtonGeneral
                                    onClick={() => handleClick()}
                                    startIcon={
                                        <FileUploadIcon color="secondary" />
                                    }
                                    title="Cargar"
                                    sx={{ mr: 1 }}
                                />
                                <ButtonGeneral
                                    onClick={() => onClose(false)}
                                    startIcon={<CancelIcon color="secondary" />}
                                    title="Cancelar"
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
            {loading ? (
                <ModalLoading
                    open={loading}
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : null}
        </>
    );
};

export default ModalCaseClosure;
